import { render, staticRenderFns } from "./MedOcuEventos.vue?vue&type=template&id=47d75b6f&scoped=true"
import script from "./MedOcuEventos.vue?vue&type=script&lang=js"
export * from "./MedOcuEventos.vue?vue&type=script&lang=js"
import style0 from "./MedOcuEventos.vue?vue&type=style&index=0&id=47d75b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d75b6f",
  null
  
)

export default component.exports